import React from 'react';
import styles from '../../chatAssist.module.scss';
import { msgInfo } from '../../constants';
import MarkdownComponent from '../MarkdownComponent/MarkdownComponent';

const MessagesContainer = ({
  messages,
  firstQuestionRef,
  firstResponseRef,
  displayedLines,
  isTyping,
}) => {
  return messages.map((msg, index) => {
    const isFirstQuestion = index === 0 && msg.type === msgInfo.sender;
    const isFirstResponse = index === 0 && msg.type === msgInfo.recipient;

    return (
      <div
        key={index}
        ref={isFirstQuestion ? firstQuestionRef : isFirstResponse ? firstResponseRef : null}
        className={msg.type === msgInfo?.recipient ? styles.messageIA : styles.messageUser}
      >
        {msgInfo?.recipient === msg.type ? (
          isFirstResponse && isTyping ? (
            displayedLines.map((line, i) => (
              <div key={i} className={styles.containerMarkDown}>
                <MarkdownComponent>{line}</MarkdownComponent>
              </div>
            ))
          ) : (
            <div className={styles.containerMarkDown}>
              <MarkdownComponent>{msg.text.replace(/\n/g, '  \n')}</MarkdownComponent>
            </div>
          )
        ) : (
          msg.text
        )}
      </div>
    );
  });
};

export default MessagesContainer;
